<template>
  <FilterDetailPopover
    v-model:is-include="isInclude"
    :title="title"
    is-switch
    :is-display-only="isDisplayOnly"
    :key-name="keyName"
    @hide="popoverHide"
    @show="popoverShow"
  >
    <template #reference>
      <BLayout
        align-center
      >
        <BListItem>
          <template #header>
            <BLayout
              justify-space-between
            >
              <div>{{ title }}</div>
              <div
                class="grouping-text"
                :class="{ 'is-include': incExc === 'inc' }"
              >
                {{ groupingText }}
              </div>
            </BLayout>
          </template>
          <div>{{ value }}</div>
        </BListItem>
      </BLayout>
    </template>
    <div>
      <FilterItemCheckbox
        v-model:checked-item="checkedItem"
        :candidate-items="candidateItems"
      />
    </div>
  </FilterDetailPopover>
</template>

<script>
import lodash from 'lodash';
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import FilterDetailPopover from '@/components/organisms/user/leadList/filter/FilterDetailPopover.vue';
import FilterItemCheckbox from '@/components/organisms/user/leadList/filter/FilterItemCheckbox.vue';
import { getIncExc } from '@/composable/user/leadList/lead-filter';

export default {
  components: {
    FilterDetailPopover,
    FilterItemCheckbox,
  },
  props: {
    leadListFilterParams: {
      type: Object,
      default () {
        return {};
      },
    },
    isDisplayOnly: {
      type: Boolean,
      default: false,
    },
    keyName: {
      type: String,
      require: true,
    },
  },
  emits: [
    'hide',
  ],
  data () {
    return {
      checkedItem: [],
      isInclude: true,
    };
  },
  computed: {
    ...mapGetters('user', [
      'businessCategoryCandidates',
    ]),
    candidateItems () {
      return this.businessCategoryCandidates.map((candidate) => ({ label: candidate, value: candidate }));
    },
    title () {
      return this.$t(`filterSelect.companyInfo.item.${this.keyName}`);
    },
    value () {
      if (this.target == null || this.targetDetail.length === 0) return '-';
      return this.targetDetail.join(' / ');
    },
    groupingText () {
      if (this.target == null || this.targetDetail.length === 0) return;
      return this.$t(`general.filter.${this.incExc}`);
    },
    target () {
      return this.leadListFilterParams[this.keyName];
    },
    targetDetail () {
      if (this.target == null) return [];
      return this.target[this.incExc].or.map(v => v);
    },
    incExc () {
      return getIncExc(this.target);
    },
  },
  created () {
    this.getBusinessCategoryCandidatesAction();
  },
  methods: {
    ...mapWaitingActions('user', {
      getBusinessCategoryCandidatesAction: 'getBusinessCategoryCandidatesWait',
    }),
    popoverShow () {
      this.checkedItem = lodash.cloneDeep(this.targetDetail);
      this.isInclude = this.incExc === 'inc';
    },
    popoverHide () {
      const grouping = this.isInclude ? 'inc' : 'exc';
      this.$emit('hide', { [grouping]: { or: this.checkedItem } });
    },
  },
};
</script>

<style lang="scss" scoped>
  .item-filter-area {
    border: 1px solid $bdcolor-base;
    border-radius: 4px;

    &-input {
      border-bottom: 1px solid $bdcolor-base;
    }

    &-candidate {
      padding: $basespace-200;
    }
  }
  .grouping-text {
    color: $basecolor-cold;
    &.is-include {
      color: $basecolor-hot;
    }
  }
</style>
